(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 4184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 1227:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(3454);
/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */

exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (() => {
	let warned = false;

	return () => {
		if (!warned) {
			warned = true;
			console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
		}
	};
})();

/**
 * Colors.
 */

exports.colors = [
	'#0000CC',
	'#0000FF',
	'#0033CC',
	'#0033FF',
	'#0066CC',
	'#0066FF',
	'#0099CC',
	'#0099FF',
	'#00CC00',
	'#00CC33',
	'#00CC66',
	'#00CC99',
	'#00CCCC',
	'#00CCFF',
	'#3300CC',
	'#3300FF',
	'#3333CC',
	'#3333FF',
	'#3366CC',
	'#3366FF',
	'#3399CC',
	'#3399FF',
	'#33CC00',
	'#33CC33',
	'#33CC66',
	'#33CC99',
	'#33CCCC',
	'#33CCFF',
	'#6600CC',
	'#6600FF',
	'#6633CC',
	'#6633FF',
	'#66CC00',
	'#66CC33',
	'#9900CC',
	'#9900FF',
	'#9933CC',
	'#9933FF',
	'#99CC00',
	'#99CC33',
	'#CC0000',
	'#CC0033',
	'#CC0066',
	'#CC0099',
	'#CC00CC',
	'#CC00FF',
	'#CC3300',
	'#CC3333',
	'#CC3366',
	'#CC3399',
	'#CC33CC',
	'#CC33FF',
	'#CC6600',
	'#CC6633',
	'#CC9900',
	'#CC9933',
	'#CCCC00',
	'#CCCC33',
	'#FF0000',
	'#FF0033',
	'#FF0066',
	'#FF0099',
	'#FF00CC',
	'#FF00FF',
	'#FF3300',
	'#FF3333',
	'#FF3366',
	'#FF3399',
	'#FF33CC',
	'#FF33FF',
	'#FF6600',
	'#FF6633',
	'#FF9900',
	'#FF9933',
	'#FFCC00',
	'#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

// eslint-disable-next-line complexity
function useColors() {
	// NB: In an Electron preload script, document will be defined but not fully
	// initialized. Since we know we're in Chrome, we'll just detect this case
	// explicitly
	if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
		return true;
	}

	// Internet Explorer and Edge do not support colors.
	if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
		return false;
	}

	// Is webkit? http://stackoverflow.com/a/16459606/376773
	// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
		// Is firebug? http://stackoverflow.com/a/398120/376773
		(typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
		// Is firefox >= v31?
		// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
		// Double check webkit in userAgent just in case we are in a worker
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	args[0] = (this.useColors ? '%c' : '') +
		this.namespace +
		(this.useColors ? ' %c' : ' ') +
		args[0] +
		(this.useColors ? '%c ' : ' ') +
		'+' + module.exports.humanize(this.diff);

	if (!this.useColors) {
		return;
	}

	const c = 'color: ' + this.color;
	args.splice(1, 0, c, 'color: inherit');

	// The final "%c" is somewhat tricky, because there could be other
	// arguments passed either before or after the %c, so we need to
	// figure out the correct index to insert the CSS into
	let index = 0;
	let lastC = 0;
	args[0].replace(/%[a-zA-Z%]/g, match => {
		if (match === '%%') {
			return;
		}
		index++;
		if (match === '%c') {
			// We only are interested in the *last* %c
			// (the user may have provided their own)
			lastC = index;
		}
	});

	args.splice(lastC, 0, c);
}

/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */
exports.log = console.debug || console.log || (() => {});

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	try {
		if (namespaces) {
			exports.storage.setItem('debug', namespaces);
		} else {
			exports.storage.removeItem('debug');
		}
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */
function load() {
	let r;
	try {
		r = exports.storage.getItem('debug');
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}

	// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	if (!r && typeof process !== 'undefined' && 'env' in process) {
		r = process.env.DEBUG;
	}

	return r;
}

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
	try {
		// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
		// The Browser also has localStorage in the global context.
		return localStorage;
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

module.exports = __webpack_require__(2447)(exports);

const {formatters} = module.exports;

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
	try {
		return JSON.stringify(v);
	} catch (error) {
		return '[UnexpectedJSONParseError]: ' + error.message;
	}
};


/***/ }),

/***/ 2447:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
	createDebug.debug = createDebug;
	createDebug.default = createDebug;
	createDebug.coerce = coerce;
	createDebug.disable = disable;
	createDebug.enable = enable;
	createDebug.enabled = enabled;
	createDebug.humanize = __webpack_require__(7824);
	createDebug.destroy = destroy;

	Object.keys(env).forEach(key => {
		createDebug[key] = env[key];
	});

	/**
	* The currently active debug mode names, and names to skip.
	*/

	createDebug.names = [];
	createDebug.skips = [];

	/**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/
	createDebug.formatters = {};

	/**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/
	function selectColor(namespace) {
		let hash = 0;

		for (let i = 0; i < namespace.length; i++) {
			hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
			hash |= 0; // Convert to 32bit integer
		}

		return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
	}
	createDebug.selectColor = selectColor;

	/**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/
	function createDebug(namespace) {
		let prevTime;
		let enableOverride = null;
		let namespacesCache;
		let enabledCache;

		function debug(...args) {
			// Disabled?
			if (!debug.enabled) {
				return;
			}

			const self = debug;

			// Set `diff` timestamp
			const curr = Number(new Date());
			const ms = curr - (prevTime || curr);
			self.diff = ms;
			self.prev = prevTime;
			self.curr = curr;
			prevTime = curr;

			args[0] = createDebug.coerce(args[0]);

			if (typeof args[0] !== 'string') {
				// Anything else let's inspect with %O
				args.unshift('%O');
			}

			// Apply any `formatters` transformations
			let index = 0;
			args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
				// If we encounter an escaped % then don't increase the array index
				if (match === '%%') {
					return '%';
				}
				index++;
				const formatter = createDebug.formatters[format];
				if (typeof formatter === 'function') {
					const val = args[index];
					match = formatter.call(self, val);

					// Now we need to remove `args[index]` since it's inlined in the `format`
					args.splice(index, 1);
					index--;
				}
				return match;
			});

			// Apply env-specific formatting (colors, etc.)
			createDebug.formatArgs.call(self, args);

			const logFn = self.log || createDebug.log;
			logFn.apply(self, args);
		}

		debug.namespace = namespace;
		debug.useColors = createDebug.useColors();
		debug.color = createDebug.selectColor(namespace);
		debug.extend = extend;
		debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

		Object.defineProperty(debug, 'enabled', {
			enumerable: true,
			configurable: false,
			get: () => {
				if (enableOverride !== null) {
					return enableOverride;
				}
				if (namespacesCache !== createDebug.namespaces) {
					namespacesCache = createDebug.namespaces;
					enabledCache = createDebug.enabled(namespace);
				}

				return enabledCache;
			},
			set: v => {
				enableOverride = v;
			}
		});

		// Env-specific initialization logic for debug instances
		if (typeof createDebug.init === 'function') {
			createDebug.init(debug);
		}

		return debug;
	}

	function extend(namespace, delimiter) {
		const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
		newDebug.log = this.log;
		return newDebug;
	}

	/**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/
	function enable(namespaces) {
		createDebug.save(namespaces);
		createDebug.namespaces = namespaces;

		createDebug.names = [];
		createDebug.skips = [];

		let i;
		const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
		const len = split.length;

		for (i = 0; i < len; i++) {
			if (!split[i]) {
				// ignore empty strings
				continue;
			}

			namespaces = split[i].replace(/\*/g, '.*?');

			if (namespaces[0] === '-') {
				createDebug.skips.push(new RegExp('^' + namespaces.slice(1) + '$'));
			} else {
				createDebug.names.push(new RegExp('^' + namespaces + '$'));
			}
		}
	}

	/**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/
	function disable() {
		const namespaces = [
			...createDebug.names.map(toNamespace),
			...createDebug.skips.map(toNamespace).map(namespace => '-' + namespace)
		].join(',');
		createDebug.enable('');
		return namespaces;
	}

	/**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/
	function enabled(name) {
		if (name[name.length - 1] === '*') {
			return true;
		}

		let i;
		let len;

		for (i = 0, len = createDebug.skips.length; i < len; i++) {
			if (createDebug.skips[i].test(name)) {
				return false;
			}
		}

		for (i = 0, len = createDebug.names.length; i < len; i++) {
			if (createDebug.names[i].test(name)) {
				return true;
			}
		}

		return false;
	}

	/**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/
	function toNamespace(regexp) {
		return regexp.toString()
			.substring(2, regexp.toString().length - 2)
			.replace(/\.\*\?$/, '*');
	}

	/**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/
	function coerce(val) {
		if (val instanceof Error) {
			return val.stack || val.message;
		}
		return val;
	}

	/**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/
	function destroy() {
		console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
	}

	createDebug.enable(createDebug.load());

	return createDebug;
}

module.exports = setup;


/***/ }),

/***/ 7824:
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),

/***/ 7635:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var _debug=_interopRequireDefault(__webpack_require__(1227));Object.defineProperty(exports, "__esModule", ({value:!0})),exports.init=init,exports.pageview=pageview,exports.reachGoal=reachGoal;function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}var log=(0,_debug.default)("analytics");function init(a){log("Analytics init triggered for ".concat(a))}function pageview(){log("Pageview triggered for ".concat(window.location.pathname))}function reachGoal(){for(var a=arguments.length,b=Array(a),c=0;c<a;c++)b[c]=arguments[c];log.apply(void 0,["Goal reached:"].concat(b))}

/***/ }),

/***/ 9508:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:!0})),exports.init=init,exports.pageview=pageview,exports.reachGoal=reachGoal;var key,_reactYm=__webpack_require__(8273),IS_BROWSER="undefined"!=typeof window;function init(a){key="yaCounter".concat(a),IS_BROWSER&&!window[key]&&a&&_reactYm.ym.initialize(a)}function pageview(){window[key]&&window[key].hit(window.location.pathname)}function reachGoal(){if(window[key]){var a;(a=window[key]).reachGoal.apply(a,arguments)}}

/***/ }),

/***/ 2351:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0}),exports["default"]=void 0;var _react=__webpack_require__(7294),prodLytics=_interopRequireWildcard(__webpack_require__(9508)),devLytics=_interopRequireWildcard(__webpack_require__(7635));function _interopRequireWildcard(a){if(a&&a.__esModule)return a;var b={};if(null!=a)for(var c in a)if(Object.prototype.hasOwnProperty.call(a,c)){var d=Object.defineProperty&&Object.getOwnPropertyDescriptor?Object.getOwnPropertyDescriptor(a,c):{};d.get||d.set?Object.defineProperty(b,c,d):b[c]=a[c]}return b.default=a,b}function _typeof(a){return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},_typeof(a)}function _objectSpread(a){for(var b=1;b<arguments.length;b++){var c=null==arguments[b]?{}:arguments[b],d=Object.keys(c);"function"==typeof Object.getOwnPropertySymbols&&(d=d.concat(Object.getOwnPropertySymbols(c).filter(function(a){return Object.getOwnPropertyDescriptor(c,a).enumerable}))),d.forEach(function(b){_defineProperty(a,b,c[b])})}return a}function _classCallCheck(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}function _defineProperties(a,b){for(var c,d=0;d<b.length;d++)c=b[d],c.enumerable=c.enumerable||!1,c.configurable=!0,"value"in c&&(c.writable=!0),Object.defineProperty(a,c.key,c)}function _createClass(a,b,c){return b&&_defineProperties(a.prototype,b),c&&_defineProperties(a,c),a}function _possibleConstructorReturn(a,b){return b&&("object"===_typeof(b)||"function"==typeof b)?b:_assertThisInitialized(a)}function _getPrototypeOf(a){return _getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function(a){return a.__proto__||Object.getPrototypeOf(a)},_getPrototypeOf(a)}function _inherits(a,b){if("function"!=typeof b&&null!==b)throw new TypeError("Super expression must either be null or a function");a.prototype=Object.create(b&&b.prototype,{constructor:{value:a,writable:!0,configurable:!0}}),b&&_setPrototypeOf(a,b)}function _setPrototypeOf(a,b){return _setPrototypeOf=Object.setPrototypeOf||function(a,b){return a.__proto__=b,a},_setPrototypeOf(a,b)}function _assertThisInitialized(a){if(void 0===a)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return a}function _defineProperty(a,b,c){return b in a?Object.defineProperty(a,b,{value:c,enumerable:!0,configurable:!0,writable:!0}):a[b]=c,a}function isLocal(a){return location.hostname===a}function isDev(){return"production"!=="production"}var _default=function(a,b){var c=2<arguments.length&&arguments[2]!==void 0?arguments[2]:{},d=c.localhost,e=void 0===d?"localhost":d;return function(c){var d=/*#__PURE__*/function(d){function f(){var a,b;_classCallCheck(this,f);for(var c=arguments.length,d=Array(c),e=0;e<c;e++)d[e]=arguments[e];return b=_possibleConstructorReturn(this,(a=_getPrototypeOf(f)).call.apply(a,[this].concat(d))),_defineProperty(_assertThisInitialized(_assertThisInitialized(b)),"state",{analytics:void 0}),b}return _inherits(f,d),_createClass(f,[{key:"componentDidMount",value:function g(){// check if it should track
var c=isLocal(e)||isDev(),d=c?devLytics:prodLytics;// check if it should use production or dev analytics
d.init(a),d.pageview();// save possible previously defined callback
var f=b.onRouteChangeComplete;b.onRouteChangeComplete=function(){"function"==typeof f&&f(),d.pageview()},this.setState({analytics:d})}},{key:"render",value:function a(){return(0,_react.createElement)(c,_objectSpread({},this.props,{analytics:this.state.analytics}))}}]),f}(_react.Component);return c.getInitialProps&&(d.getInitialProps=c.getInitialProps),d}};exports["default"]=_default;

/***/ }),

/***/ 7170:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(2351);


/***/ }),

/***/ 9135:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(1686)


/***/ }),

/***/ 1752:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(6949)


/***/ }),

/***/ 3454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(7663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(1242);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
const basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        const normalizeLocalePath = (__webpack_require__(2554).normalizeLocalePath);
        const detectDomainLocale = (__webpack_require__(4643).detectDomainLocale);
        const target = locale || normalizeLocalePath(path, locales).detectedLocale;
        const domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            const proto = "http".concat(domain.http ? "" : "s", "://");
            const finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"use client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _object_without_properties_loose = (__webpack_require__(7273)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _router = __webpack_require__(1003);
var _formatUrl = __webpack_require__(7795);
var _addLocale = __webpack_require__(4465);
var _routerContext = __webpack_require__(2692);
var _appRouterContext = __webpack_require__(8245);
var _useIntersection = __webpack_require__(9246);
var _getDomainLocale = __webpack_require__(227);
var _addBasePath = __webpack_require__(3468);
"use client";
const prefetched = new Set();
function prefetch(router, href, as, options) {
    if (false) {}
    if (!(0, _router).isLocalURL(href)) {
        return;
    }
    // We should only dedupe requests when experimental.optimisticClientCache is
    // disabled.
    if (!options.bypassPrefetchedCheck) {
        const locale = typeof options.locale !== "undefined" ? options.locale : "locale" in router ? router.locale : undefined;
        const prefetchedKey = href + "%" + as + "%" + locale;
        // If we've already fetched the key, then don't prefetch it again!
        if (prefetched.has(prefetchedKey)) {
            return;
        }
        // Mark this URL as prefetched.
        prefetched.add(prefetchedKey);
    }
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    Promise.resolve(router.prefetch(href, as, options)).catch((err)=>{
        if (false) {}
    });
}
function isModifiedEvent(event) {
    const { target  } = event.currentTarget;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
    const { nodeName  } = e.currentTarget;
    // anchors inside an svg have a lowercase nodeName
    const isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    const navigate = ()=>{
        // If the router is an NextRouter instance it will have `beforePopState`
        if ("beforePopState" in router) {
            router[replace ? "replace" : "push"](href, as, {
                shallow,
                locale,
                scroll
            });
        } else {
            router[replace ? "replace" : "push"](as || href, {
                forceOptimisticNavigation: !prefetchEnabled
            });
        }
    };
    if (isAppRouter) {
        // @ts-expect-error startTransition exists.
        _react.default.startTransition(navigate);
    } else {
        navigate();
    }
}
function formatStringOrUrl(urlObjOrString) {
    if (typeof urlObjOrString === "string") {
        return urlObjOrString;
    }
    return (0, _formatUrl).formatUrl(urlObjOrString);
}
/**
 * React Component that enables client-side transitions between routes.
 */ const Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) {}
    let children;
    const { href: hrefProp , as: asProp , children: childrenProp , prefetch: prefetchProp , passHref , replace , shallow , scroll , locale , onClick , onMouseEnter: onMouseEnterProp , onTouchStart: onTouchStartProp , legacyBehavior =Boolean(true) !== true  } = props, restProps = _object_without_properties_loose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "onTouchStart",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    const prefetchEnabled = prefetchProp !== false;
    const pagesRouter = _react.default.useContext(_routerContext.RouterContext);
    const appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    const router = pagesRouter != null ? pagesRouter : appRouter;
    // We're in the app directory if there is no pages router.
    const isAppRouter = !pagesRouter;
    const { href , as  } = _react.default.useMemo(()=>{
        if (!pagesRouter) {
            const resolvedHref = formatStringOrUrl(hrefProp);
            return {
                href: resolvedHref,
                as: asProp ? formatStringOrUrl(asProp) : resolvedHref
            };
        }
        const [resolvedHref1, resolvedAs] = (0, _router).resolveHref(pagesRouter, hrefProp, true);
        return {
            href: resolvedHref1,
            as: asProp ? (0, _router).resolveHref(pagesRouter, asProp) : resolvedAs || resolvedHref1
        };
    }, [
        pagesRouter,
        hrefProp,
        asProp
    ]);
    const previousHref = _react.default.useRef(href);
    const previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    let child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    } else {
        if (false) { var ref; }
    }
    const childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    const [setIntersectionRef, isVisible, resetVisible] = (0, _useIntersection).useIntersection({
        rootMargin: "200px"
    });
    const setRef = _react.default.useCallback((el)=>{
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    // Prefetch the URL if we haven't already and it's visible.
    _react.default.useEffect(()=>{
        if (!router) {
            return;
        }
        // If we don't need to prefetch the URL, don't do prefetch.
        if (!isVisible || !prefetchEnabled) {
            return;
        }
        // Prefetch the URL.
        prefetch(router, href, as, {
            locale
        });
    }, [
        as,
        href,
        isVisible,
        locale,
        prefetchEnabled,
        pagesRouter == null ? void 0 : pagesRouter.locale,
        router
    ]);
    const childProps = {
        ref: setRef,
        onClick: (e)=>{
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!router) {
                return;
            }
            if (e.defaultPrevented) {
                return;
            }
            linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled);
        },
        onMouseEnter: (e)=>{
            if (!legacyBehavior && typeof onMouseEnterProp === "function") {
                onMouseEnterProp(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if (!router) {
                return;
            }
            if (!prefetchEnabled && isAppRouter) {
                return;
            }
            prefetch(router, href, as, {
                locale,
                priority: true,
                // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
                bypassPrefetchedCheck: true
            });
        },
        onTouchStart: (e)=>{
            if (!legacyBehavior && typeof onTouchStartProp === "function") {
                onTouchStartProp(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onTouchStart === "function") {
                child.props.onTouchStart(e);
            }
            if (!router) {
                return;
            }
            if (!prefetchEnabled && isAppRouter) {
                return;
            }
            prefetch(router, href, as, {
                locale,
                priority: true,
                // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
                bypassPrefetchedCheck: true
            });
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        const curLocale = typeof locale !== "undefined" ? locale : pagesRouter == null ? void 0 : pagesRouter.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        const localeDomain = (pagesRouter == null ? void 0 : pagesRouter.isLocaleDomain) && (0, _getDomainLocale).getDomainLocale(as, curLocale, pagesRouter == null ? void 0 : pagesRouter.locales, pagesRouter == null ? void 0 : pagesRouter.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, pagesRouter == null ? void 0 : pagesRouter.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 2554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
const normalizeLocalePath = (pathname, locales)=>{
    if (true) {
        return (__webpack_require__(4769).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 9246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(7294);
var _requestIdleCallback = __webpack_require__(4686);
const hasIntersectionObserver = typeof IntersectionObserver === "function";
const observers = new Map();
const idList = [];
function createObserver(options) {
    const id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    const existing = idList.find((obj)=>obj.root === id.root && obj.margin === id.margin);
    let instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    const elements = new Map();
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            const callback = elements.get(entry.target);
            const isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id,
        observer,
        elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
function observe(element, callback, options) {
    const { id , observer , elements  } = createObserver(options);
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            const index = idList.findIndex((obj)=>obj.root === id.root && obj.margin === id.margin);
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function useIntersection(param) {
    let { rootRef , rootMargin , disabled  } = param;
    const isDisabled = disabled || !hasIntersectionObserver;
    const [visible, setVisible] = (0, _react).useState(false);
    const [element, setElement] = (0, _react).useState(null);
    (0, _react).useEffect(()=>{
        if (hasIntersectionObserver) {
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                const unobserve = observe(element, (isVisible)=>isVisible && setVisible(isVisible), {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin
                });
                return unobserve;
            }
        } else {
            if (!visible) {
                const idleCallback = (0, _requestIdleCallback).requestIdleCallback(()=>setVisible(true));
                return ()=>(0, _requestIdleCallback).cancelIdleCallback(idleCallback);
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    const resetVisible = (0, _react).useCallback(()=>{
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 1686:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useAmp = useAmp;
var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(7294));
var _ampContext = __webpack_require__(610);
var _ampMode = __webpack_require__(532);
function useAmp() {
    // Don't assign the context value to a variable to save bytes
    return (0, _ampMode).isInAmpMode(_react.default.useContext(_ampContext.AmpStateContext));
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=amp.js.map


/***/ }),

/***/ 9157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTranslation; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _locales__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2470);



function useTranslation() {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    const locale = router === null || router === void 0 ? void 0 : router.locale;
    const asPath = router === null || router === void 0 ? void 0 : router.asPath;
    const setLocale = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((locale)=>{
        router.push(asPath, asPath, {
            locale
        });
    }, [
        asPath,
        router
    ]);
    const t = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((keyString)=>_locales__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[locale][keyString], [
        locale
    ]);
    const isForeign = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>locale !== "ru", [
        locale
    ]);
    return {
        t,
        locale,
        setLocale,
        isForeign
    };
}


/***/ }),

/***/ 2470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_locales; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/lib/locales/en.tsx


const en = {
    BLOG_TITLE: "Alexander Sidorenko's Blog",
    BLOG_DESCRIPTION: "Alexander Sidorenko's blog with notes and full-length articles about development, music, and life",
    CREATIVITY_TITLE: "Creativity of Alexander Sidorenko",
    CREATIVITY_DESCRIPTION: "A page with publications of my work. I do music, write poetry and short stories.",
    ARIA_THEME_SWITCH: "Theme switch",
    MENU_ABOUT_ME: "About me",
    MENU_BLOG: "Blog",
    MENU_CREATIVITY: "Creativity",
    FIRSTNAME: "Alexandr",
    LASTNAME: "Sidorenko",
    FULL_NAME: "Alexandr Sidorenko",
    CITY: "Novosibirsk",
    COUNTRY: "Russia",
    PUBLISHED: "Published",
    CREATED: "Created",
    STORY: "Story",
    POEM: "Poem",
    POETRY: "A selection of poems",
    SINGLE: "Single",
    EP: "EP",
    ALBUM: "Album",
    WORK: "WORK",
    ARTICLE: "Article",
    RIGHTS: "All rights reserved",
    NOT_FOUND: "Page not found",
    BACK_TO_MAIN_PAGE: "Go to Home",
    UNKNOWN_ERROR: "Unknown error",
    RESTART: "Refresh page",
    TW_ADULTHOOD: "The material is intended for persons over 18 years of age.",
    TW_RELIGION: "This message (material), describes the mental anguish of a disappointed person in life, acting as a lyrical hero, and is not intended to offend the feelings of believers. If you are sensitive to this topic, stop reading immediately and close your browser tab.",
    TW_ADDICTION: "This material mentions realistic scenes of alcohol, tobacco products and/or other narcotic or psychoactive substances. Their use is dangerous to health and/or prohibited by law.",
    TW_TRANSLATION: "This text was translated by DeepL from a my non-native language.",
    AVATAR_ALT: "Alexander Sidorenko wearing a Mexican hat and holding a banjo",
    KEYWORDS: "Alexander Sidorenko, programmer, deceased leader, hacker, hacker, Lenin, javascripter, backender",
    HEAD_DESCRIPTION: "Programmer, deceased leader, hacker. Participant of hackathons and CTF. Founder of Blurred Education I want to play Letov on all strings and develop a bombastic project with Blurred Technologies.",
    DESCRIPTION: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            '"It\'s alchemy!" - I say as I write code. Programmer,',
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "https://twitter.com/batyshkaLenin",
                children: "deceased leader"
            }),
            "hacker. I've participated in hackathons, information security competitions, and run the Blurred Education project. I want to play",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "https://www.gr-oborona.ru/texts/1056898718.html",
                children: '"My Defense"'
            }),
            " ",
            "on all stringed musical instruments (I've played six now) and develop a bombastic project with the",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "https://blur.tech/",
                children: "Blurred Technologies"
            }),
            " team."
        ]
    })
};

;// CONCATENATED MODULE: ./src/lib/locales/ru.tsx


const ru = {
    BLOG_TITLE: "Блог Александра Сидоренко",
    BLOG_DESCRIPTION: "Блог Александра Сидоренко с заметками и полноценными статьями о разработке, музыке и жизни",
    CREATIVITY_TITLE: "Творчество Александра Сидоренко",
    CREATIVITY_DESCRIPTION: "Страница с публикациями моего творчества. Я занимаюсь музыкой, пишу стихи и рассказы.",
    ARIA_THEME_SWITCH: "Переключатель темы",
    MENU_ABOUT_ME: "Обо мне",
    MENU_BLOG: "Блог",
    MENU_CREATIVITY: "Творчество",
    FIRSTNAME: "Александр",
    LASTNAME: "Сидоренко",
    FULL_NAME: "Александр Сидоренко",
    CITY: "Новосибирск",
    COUNTRY: "Россия",
    PUBLISHED: "Опубликовано",
    CREATED: "Создано",
    STORY: "Рассказ",
    POEM: "Стих",
    POETRY: "Подборка стихов",
    SINGLE: "Сингл",
    EP: "EP",
    ALBUM: "Альбом",
    WORK: "Произведение",
    ARTICLE: "Статья",
    RIGHTS: "Все права защищены",
    NOT_FOUND: "Страница не найдена",
    BACK_TO_MAIN_PAGE: "Перейти на главную",
    UNKNOWN_ERROR: "Неизвестная ошибка",
    RESTART: "Обновить страницу",
    TW_ADULTHOOD: "Материал предназначен для лиц старше 18 лет.",
    TW_RELIGION: "Данное сообщение (материал), описывает душевные терзания разочарованного в жизни человека, выполняющим функции лирического героя и не несёт в себе цели оскорбления чувств верующих. Если вы чувствительны к этой теме немедленно прекратите чтение страницы и закройте вкладку браузера.",
    TW_ADDICTION: "В данном материале упомянуты реалистичные сцены употребления алкоголя, табачных изделий и (или) других наркотических или психоактивных веществ. Их употребление опасно для здоровья и (или) запрещено законом.",
    TW_TRANSLATION: "Этот текст был переведен DeepL с неродного для меня языка",
    AVATAR_ALT: "Александр Сидоренко в мексиканской шляпе и с банджо в руках",
    KEYWORDS: "Александр Сидоренко, программист, усопший вождь, взломщик, хакер, батюшка Ленин, Ленин, джаваскриптер, бэкэндер",
    HEAD_DESCRIPTION: "Программист, усопший вождь, взломщик. Участник хакатонов и CTF. Основатель Blurred Education Хочу сыграть Летова на всех струнных и разработать бомбический проект с Blurred Technologies.",
    DESCRIPTION: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            '"Это алхимия!" - говорю я, когда пишу код. Программист, усопший вождь, взломщик. Участвовал в хакатонах, соревнованиях по информационной безопасности и вел образовательный проект Blurred Education. Хочу сыграть ООО "Моя оборона" на всех струнных музыкальных инструментах (сейчас сыграл на шести) и разработать бомбический проект с командой',
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "https://blur.tech/",
                children: "Blurred Technologies"
            }),
            "."
        ]
    })
};

;// CONCATENATED MODULE: ./src/lib/locales/index.ts


const locales = {
    en: en,
    ru: ru
};
/* harmony default export */ var lib_locales = (locales);


/***/ }),

/***/ 9168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ok": function() { return /* reexport */ CreativeMusic; },
  "oi": function() { return /* reexport */ CreativeWriting; },
  "go": function() { return /* reexport */ Locale; },
  "Q2": function() { return /* reexport */ Theme; },
  "Pq": function() { return /* reexport */ TriggerWarning; }
});

;// CONCATENATED MODULE: ./src/lib/types/localization.ts
var Locale;
(function(Locale) {
    Locale["RU"] = "ru";
    Locale["EN"] = "en";
})(Locale || (Locale = {}));

;// CONCATENATED MODULE: ./src/lib/types/theme.ts
var Theme;
(function(Theme) {
    Theme["Light"] = "light";
    Theme["Dark"] = "dark";
})(Theme || (Theme = {}));

;// CONCATENATED MODULE: ./src/lib/types/creativity.ts
var TriggerWarning;
(function(TriggerWarning) {
    TriggerWarning["Adulthood"] = "18";
    TriggerWarning["Addiction"] = "addict";
    TriggerWarning["Religion"] = "religion";
    TriggerWarning["Translation"] = "deepl";
})(TriggerWarning || (TriggerWarning = {}));
var CreativeWriting;
(function(CreativeWriting) {
    CreativeWriting["Poem"] = "poem";
    CreativeWriting["Poetry"] = "poetry";
    CreativeWriting["Story"] = "story";
})(CreativeWriting || (CreativeWriting = {}));
var CreativeMusic;
(function(CreativeMusic) {
    CreativeMusic["Single"] = "single";
    CreativeMusic["EP"] = "ep";
    CreativeMusic["Album"] = "album";
})(CreativeMusic || (CreativeMusic = {}));

;// CONCATENATED MODULE: ./src/lib/types/index.ts







/***/ }),

/***/ 1242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/styles/index.css
var styles = __webpack_require__(8610);
// EXTERNAL MODULE: ./public/fonts/fonts.css
var fonts = __webpack_require__(3300);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@vercel/analytics/dist/react/index.js
/* provided dependency */ var process = __webpack_require__(3454);
// src/react.tsx


// src/queue.ts
var initQueue = () => {
  if (window.va)
    return;
  window.va = function a(...params) {
    (window.vaq = window.vaq || []).push(params);
  };
};

// src/utils.ts
function isBrowser() {
  return typeof window !== "undefined";
}
function isDevelopment() {
  if (typeof process === "undefined")
    return false;
  return  false || "production" === "test";
}
function getMode(mode = "auto") {
  if (mode === "auto") {
    return isDevelopment() ? "development" : "production";
  }
  return mode;
}

// src/generic.ts
var inject = (props = {
  debug: true
}) => {
  var _a;
  if (!isBrowser())
    return;
  const mode = getMode(props.mode);
  initQueue();
  if (props.beforeSend) {
    (_a = window.va) == null ? void 0 : _a.call(window, "beforeSend", props.beforeSend);
  }
  const src = mode === "development" ? "https://cdn.vercel-insights.com/v1/script.debug.js" : "/_vercel/insights/script.js";
  if (document.head.querySelector(`script[src*="${src}"]`))
    return;
  const script = document.createElement("script");
  script.src = src;
  script.defer = true;
  if (mode === "development" && props.debug === false) {
    script.setAttribute("data-debug", "false");
  }
  document.head.appendChild(script);
};

// src/react.tsx
function Analytics({
  beforeSend,
  debug = true,
  mode = "auto"
}) {
  (0,react.useEffect)(() => {
    inject({ beforeSend, debug, mode });
  }, [beforeSend, debug, mode]);
  return null;
}

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/next-ym/index.js
var next_ym = __webpack_require__(7170);
// EXTERNAL MODULE: ./node_modules/next/amp.js
var amp = __webpack_require__(9135);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/styles/Footer.module.scss
var Footer_module = __webpack_require__(6257);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ./src/components/layout/Footer.tsx





const Footer = ()=>{
    const isAmp = (0,amp.useAmp)();
    return !isAmp ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (Footer_module_default()).footer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (Footer_module_default()).rights,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_module_default()).copy,
                        children: [
                            "\xa9 2020-",
                            new Date().getFullYear()
                        ]
                    }),
                    "|",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_module_default()).design,
                        children: [
                            "Designed by",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://vk.com/wemadefrombrokenparts",
                                children: "Meiks"
                            })
                        ]
                    }),
                    "|",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_module_default()).webringCarousel,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://xn--sr8hvo.ws/%F0%9F%89%90%F0%9F%8C%BC%F0%9F%8D%AC/previous",
                                children: "←"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "\uD83D\uDD78\uD83D\uDC8D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://xn--sr8hvo.ws/%F0%9F%89%90%F0%9F%8C%BC%F0%9F%8D%AC/next",
                                children: "→"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (Footer_module_default()).contacts,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: (Footer_module_default()).contactList,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (Footer_module_default()).contactItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://github.com/batyshkaLenin",
                                rel: "me",
                                children: isAmp ? "GitHub" : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    "aria-label": "Ссылка на GitHub",
                                    className: "icon-github-circled",
                                    role: "link"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (Footer_module_default()).contactItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://vk.com/batyshkalenin",
                                rel: "me",
                                children: isAmp ? "ВКонтакте" : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    "aria-label": "Ссылка на ВКонтакте",
                                    className: "icon-vkontakte",
                                    role: "link"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (Footer_module_default()).contactItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://soundcloud.com/better_not_be_born",
                                rel: "me",
                                children: isAmp ? "SoundCloud" : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    "aria-label": "Ссылка на SoundCloud",
                                    className: "icon-soundcloud",
                                    role: "link"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (Footer_module_default()).contactItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://twitter.com/batyshkaLenin",
                                rel: "me",
                                children: isAmp ? "Twitter" : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    "aria-label": "Ссылка на Twitter",
                                    className: "icon-twitter",
                                    role: "link"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            className: (Footer_module_default()).contactItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://t.me/batyshka_Lenin",
                                rel: "me",
                                children: isAmp ? "Telegram" : /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    "aria-label": "Ссылка на Telegram",
                                    className: "icon-telegram",
                                    role: "link"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    }) : null;
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/lib/hooks/useTranslation.ts
var useTranslation = __webpack_require__(9157);
// EXTERNAL MODULE: ./src/lib/types/index.ts + 3 modules
var types = __webpack_require__(9168);
// EXTERNAL MODULE: ./src/styles/Header.module.scss
var Header_module = __webpack_require__(5397);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
// EXTERNAL MODULE: ./src/styles/Menu.module.scss
var Menu_module = __webpack_require__(7326);
var Menu_module_default = /*#__PURE__*/__webpack_require__.n(Menu_module);
;// CONCATENATED MODULE: ./src/components/layout/Menu.tsx







const Menu = ()=>{
    const isAmp = (0,amp.useAmp)();
    const router = (0,next_router.useRouter)();
    const { t  } = (0,useTranslation/* default */.Z)();
    const { asPath: path  } = router;
    return !isAmp ? /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        itemScope: true,
        itemType: "https://schema.org/SiteNavigationElement",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            itemScope: true,
            className: (Menu_module_default()).menu,
            itemProp: "about",
            itemType: "https://schema.org/ItemList",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    itemScope: true,
                    className: classnames_default()((Menu_module_default()).menuItem, path === "/" && (Menu_module_default()).active),
                    itemProp: "itemListElement",
                    itemType: "https://schema.org/ListItem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        itemProp: "item url",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            itemProp: "name",
                            children: t("MENU_ABOUT_ME")
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    itemScope: true,
                    className: classnames_default()((Menu_module_default()).menuItem, /posts/.test(path) && (Menu_module_default()).active),
                    itemProp: "itemListElement",
                    itemType: "https://schema.org/ListItem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/posts",
                        itemProp: "item url",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            itemProp: "name",
                            children: t("MENU_BLOG")
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    itemScope: true,
                    className: classnames_default()((Menu_module_default()).menuItem, /creativity/.test(path) && (Menu_module_default()).active),
                    itemProp: "itemListElement",
                    itemType: "https://schema.org/ListItem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/creativity",
                        itemProp: "item url",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            itemProp: "name",
                            children: t("MENU_CREATIVITY")
                        })
                    })
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var layout_Menu = (Menu);

;// CONCATENATED MODULE: ./src/components/layout/Header.tsx








const Header = (props)=>{
    const { t , locale , setLocale , isForeign  } = (0,useTranslation/* default */.Z)();
    const isAmp = (0,amp.useAmp)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (Header_module_default()).header,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Menu, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "settings",
                children: [
                    isAmp ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "languageSwitch",
                        onClick: ()=>setLocale(isForeign ? types/* Locale.RU */.go.RU : types/* Locale.EN */.go.EN),
                        children: locale.toUpperCase()
                    }),
                    isAmp ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Header_module_default()).settings,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            className: (Header_module_default())["switch"],
                            htmlFor: "slider",
                            id: "switch",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    "aria-checked": props.theme === "light",
                                    "aria-label": t("ARIA_THEME_SWITCH"),
                                    checked: props.theme === "light",
                                    id: "slider",
                                    role: "switch",
                                    type: "checkbox",
                                    onChange: ()=>{
                                        const newTheme = props.theme === types/* Theme.Light */.Q2.Light ? types/* Theme.Dark */.Q2.Dark : types/* Theme.Light */.Q2.Light;
                                        props.setTheme(newTheme);
                                        document.body.setAttribute("data-theme", newTheme);
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classnames_default()((Header_module_default()).slider, (Header_module_default()).round)
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/layout/index.ts



;// CONCATENATED MODULE: ./src/lib/hooks/useLocalStorage.ts

function useLocalStorage(defaultValue, key) {
    const [value, setValue] = (0,react.useState)(defaultValue);
    (0,react.useEffect)(()=>{
        const stickyValue = window.localStorage.getItem(key);
        if (stickyValue !== null) {
            setValue(JSON.parse(stickyValue));
        }
    }, [
        key
    ]);
    (0,react.useEffect)(()=>{
        window.localStorage.setItem(key, JSON.stringify(value));
    }, [
        key,
        value
    ]);
    return [
        value,
        setValue
    ];
}

;// CONCATENATED MODULE: ./src/lib/hooks/index.ts



;// CONCATENATED MODULE: ./src/pages/_app.tsx




// @ts-expect-error "Yandex Metrika without types"










const { publicRuntimeConfig , serverRuntimeConfig  } = config_default()();
const isServerSide = "object" === "undefined";
const { YM_CODE , GA_CODE  } = isServerSide ? serverRuntimeConfig : publicRuntimeConfig;
function _App(param) {
    let { Component , pageProps  } = param;
    const isAmp = (0,amp.useAmp)();
    const [theme, setTheme] = useLocalStorage(types/* Theme.Dark */.Q2.Dark, "theme");
    (0,react.useEffect)(()=>{
        document.body.setAttribute("data-theme", theme);
    }, [
        theme
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    isAmp ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: "minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no, viewport-fit=cover",
                        name: "viewport"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "root",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                        setTheme: setTheme,
                        theme: theme
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
                            ...pageProps
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Analytics, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                async: true,
                id: "ext-ga",
                src: "https://www.googletagmanager.com/gtag/js?id=".concat(GA_CODE),
                strategy: "afterInteractive"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "int-ga",
                strategy: "afterInteractive",
                children: "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '".concat(GA_CODE, "');")
            })
        ]
    });
}
const App = (0,next_ym["default"])(YM_CODE, (router_default()))(_App);
/* harmony default export */ var _app = (App);


/***/ }),

/***/ 6257:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__oaUOW","webring":"Footer_webring__ny4Lt","rights":"Footer_rights__SZ7_D","copy":"Footer_copy__4XlNN","design":"Footer_design__o6cdt","webringCarousel":"Footer_webringCarousel___ydyr","contactList":"Footer_contactList___3wFt","contactItem":"Footer_contactItem__7PyqC","contacts":"Footer_contacts__dmatX"};

/***/ }),

/***/ 5397:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__R_kkv","switch":"Header_switch__SGbDU","slider":"Header_slider__2e7qH","round":"Header_round__Flypr","settings":"Header_settings__fBnfp"};

/***/ }),

/***/ 7326:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__LwNw1","menuItem":"Menu_menuItem__QNfeo","active":"Menu_active__qTFtR"};

/***/ }),

/***/ 3300:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 8610:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(3121)


/***/ }),

/***/ 1664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(1551)


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(880)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports =
   false
    ? 0
    : __webpack_require__(3573)


/***/ }),

/***/ 8273:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var ym;
(function (ym) {
    function initialize(ymId, options) {
        if (!ymId) {
            return;
        }
        var customOptions = {};
        var defaultOptions = {
            id: ymId,
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true
        };
        if (options) {
            customOptions = options;
            customOptions['id'] = ymId;
        }
        (function (d, w, c) {
            (w[c] = w[c] || []).push(function () {
                try {
                    var Ya = w['Ya'];
                    w[("yaCounter" + ymId)] = new Ya.Metrika(options ? customOptions : defaultOptions);
                }
                catch (e) { }
            });
            var n = d.getElementsByTagName('script')[0], s = d.createElement('script'), f = function () { n.parentNode.insertBefore(s, n); };
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://mc.yandex.ru/metrika/watch.js';
            if (w['opera'] == '[object Opera]') {
                d.addEventListener('DOMContentLoaded', f, false);
            }
            else {
                f();
            }
        })(document, window, 'yandex_metrika_callbacks');
    }
    ym.initialize = initialize;
})(ym = exports.ym || (exports.ym = {}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(6840), __webpack_exec__(880); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);